/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';
import insertTransaction from '../views/insert-transaction/InsertTransaction.vue';
import { setBreadcrumb } from './index';

const insertTransactionRoute = {
  path: '/insert-transaction',
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - Insert Transaction Off Us',
        appBarTitle: 'Insert Transaction Off Us',
        breadcrumbs: () => [
          setBreadcrumb(
            'Insert Transaction Off Us',
            '/insert-transaction',
            true
          ),
          setBreadcrumb('Bulk Upload', '/insert-transaction'),
        ],
      },
      component: insertTransaction,
      name: 'insertTransaction',
    },
  ],
  meta: {
    title: 'BNI QRIS - Insert Transaction Off Us',
    appBarTitle: 'Insert Transaction Off Us',
  },
  component: Parent,
};
export default insertTransactionRoute;
